import React from 'react'
import JumpstartCustomerAcquisition, { getServerSideProps } from '../jumpstart-mw-ca'

/**
 * The customer acquisition page sold as the trial, from 26 October 2026 at this address alone. Since 3 November
 * 2026 /jumpstart-mw-ca sells the trial itself, so this address serves the same page for the ads that still link
 * here, under its own intake source so those sign-ups keep their attribution and Brevo list.
 */
const JumpstartCustomerAcquisitionTrial = () => <JumpstartCustomerAcquisition source="jumpstart-mw-ca-trial" />

export { getServerSideProps }

export default JumpstartCustomerAcquisitionTrial
